import { onMounted, onUnmounted } from 'vue';
import getEmbeddedInModule from '@/helpers/getEmbeddedInModule';
import InternalModules from '@/models/InternalModules';

export const useEmbeddedScrollLock = (): void => {
  const embeddedModule = getEmbeddedInModule();

  // Why: mirrors the canonical predicate in useEmbeddedHostSync — URL param alone is
  // not enough because the app can be served inside an iframe without it.
  const isEmbedded = embeddedModule !== '' || window.self !== window.top;

  // Boundary: SIU must NOT lock scroll. It relies on useEmbeddedHostResize reporting
  // document.body.scrollHeight so the host (FI) can grow the iframe to fit. Locking
  // (html { overflow: hidden }) clamps scrollHeight to the current viewport height,
  // so we would only ever report the iframe's existing size back — the host could
  // never learn the real content height and the iframe would deadlock at its initial
  // size with the content still overflowing. The FSC casemanagement host sizes its
  // iframe up front, so the lock there just removes a redundant scrollbar.
  const shouldLockScroll = isEmbedded && embeddedModule !== InternalModules.Siu;

  onMounted(() => {
    if (shouldLockScroll) {
      document.documentElement.style.overflow = 'hidden';
    }
  });

  // Why: defensive — App.vue is never unmounted in normal SPA lifecycle, but this
  // ensures tests can clean up and the composable stays reusable if extracted later.
  onUnmounted(() => {
    if (shouldLockScroll) {
      document.documentElement.style.overflow = '';
    }
  });
};
